import apiClient from 'api/apiClient';

// eslint-disable-next-line import/prefer-default-export

// We should grab all of the owners from the API since there are only a few hundred records
export const getOwners = () => apiClient.get('/v1/owners');

export default getOwners;
